<template>
<div class="item-list">
    <div class="items-section">  
        <div v-for="item in items" class="item-container" :style="itemContainerStyle" :key="item._id">
            <div  class="item-row clickable" :class="{selected: item._selected, hover: item == hoveredItem, expanded: item == expandedItem}">
                <div @click="itemClicked(item)" class="item-title" v-ripple>
                        <div @click.stop="toggleSelection(item)" class="item-check-column">
                            <v-icon v-if="item._selected">check_box</v-icon>
                            <v-icon v-else>check_box_outline_blank</v-icon>
                        </div>
                        <div @mouseenter="itemHovered(item)" @mouseleave="itemNotHovered(item)" class="item-text-column">
                            <slot name="title" v-bind:item="item">
                                {{item.name}}
                            </slot>
                        </div>
                        <div v-if="!hideExpander" class="item-button-column">
                            <v-btn @click.stop="buttonClicked(item)" @mousedown.stop color="grey darken-1" icon text>
                                <v-icon>arrow_drop_down</v-icon>
                            </v-btn>
                        </div>
                </div>

                <div class="item-content">
                    <div v-if="item == expandedItem">
                        <slot name="content" v-bind:item="item">
                            <div style="padding:10px;font-size:14px;color:#ccc;">
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero nam animi fugiat consequatur neque ea natus. Velit commodi porro modi excepturi consequatur ex, debitis, perferendis error earum deserunt inventore odit!
                            Lorem ipsum dolor sit amet consectetur adipisicing elit. Libero nam animi fugiat consequatur neque ea natus. Velit commodi porro modi excepturi consequatur ex, debitis, perferendis error earum deserunt inventore odit!
                            </div>
                        </slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

</template>

<script>
import ArrayHelpers from '../helpers/ArrayHelpers'
import Utilities from '../helpers/Utilities'
import Firestore from '../data/Firestore'
import ItemSelection from '../helpers/ItemSelection'

export default {
    data() {
        return {
            expandedItem: {},
            hoveredItem: {},
        }
    },
    components: {
    },
    
    props: {
        items: Array,
        width: String,
        icon: {
            type:String,
            default: 'mdi-hexagon-multiple'
        },
        hideExpander: Boolean,
        lock: Boolean
    },

    computed: {

        selectedItems() {
            return this.items.filter(o => o._selected)
        },

        selectionCount() {
            return this.selectedItems.length
        },

        itemContainerStyle() {
            return 'width:' + (this.width || '100%')
        }
    },

    methods: {        

        addItem() {
            this.$emit('add')
        }, 

        itemClicked(item) {
            this.selectOne(item)
            this.$emit('click', item)
        },

        buttonClicked(item) {
            if(item == this.expandedItem)
                this.contract()
            else
                this.expand(item)
        },

        contract() {
            if(Object.keys(this.expandedItem).length)
                this.$emit('contracted', this.expandedItem)
            this.expandedItem = {}
        },

        expand(item) {
            this.contract()
            this.expandedItem = item
            this.$emit('expanded', item)
        },

        itemHovered(item) {
            this.hoveredItem = item
        },
        itemNotHovered(item) {
            this.hoveredItem = {} 
        },

        selectOne(item) {
            if(!this.lock)
                this.unselectAll(this.items)
            this.$set(item, '_selected', true)
        },

        unselectAll() {
            ItemSelection.unselectAll(this.items)
        },

        toggleSelection(item) {
            ItemSelection.toggleSelection(item)
        },

    },

    watch: {
        'selectionCount': {
            deep: true,
            handler: function(newVal, oldVal) {
                this.$emit('selection-change')
            }
        },
    },

    mounted() {
        
    },

    created() {
        
    }

}
</script>

<style scoped>

    .header-bar {
        padding:8px;
        width:100%;
    }

    .items-section {
        padding:0px 5px;
        display:flex;
        flex-wrap: wrap;
    }

    .item-container { 
        padding:5px 5px;
        max-width: 100%;
    }
    .item-row {
        border: dotted 4px transparent;
        border-radius:10px;
        background-color: #fff;
        color:#666;
        transition: border-color 0.3s ease-in-out;
    }

    .item-title {
        display:flex;
        border-radius:8px;
        background-color:white;
        transition: background-color 1.5s ease;
    }

    .expanded .item-title {
        background-color:#eee;
        color:#444;
    }

    .item-check-column {
        padding-top:6px;
        padding-left:4px;

    }

    .item-text-column {
        padding: 8px;
        flex-grow: 1;
    }

    .item-button-column {
        padding-top:2px;
    }

    .item-row.selected {
        border: dotted 4px #2E9AFE;
    }

    .selected .item-check-column i {
        color: #2E9AFE;
    }

    .item-check-column i {
        color: #bbb;
    }
    .expanded .item-check-column i {
        color: #888;
    }

    .item-button-column i {
        transition: transform .6s ease-in-out;
    }

    .expanded .item-button-column i {
        transform: rotate(180deg);
    }

    .item-content{
        height:0px;
        opacity: 0;
        transition: height 0.3s ease-in-out, opacity 0.7s ease-in-out;
        overflow-y:auto;
    }
    .expanded .item-content {
        height:250px;
        opacity: 1;
    }

    @media (hover: hover) {
        .item-row.hover {
            border: dotted 4px #A9D0F5;
        }    
        .item-check-column i:hover {
            color: #0174DF;
        }
    }    
   
</style>




// WEBPACK FOOTER //
// OneOrMoreList.vue?2d225cbe